import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import H3 from '@base/H3/H3';
import PlatformBatchCard from '../../Composite/BatchCard/PlatFormBatchCard';

const Wrapper = styled.div`
  margin: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B};
`;

const StyH3 = styled(H3)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.LARGE};
    line-height: 100%;
  }
`;

const Column = styled.div`
  margin: ${Spacings.SPACING_0B} ${Spacings.SPACING_0B} ${Spacings.SPACING_6B};
`;

const CardWrapper = styled(PlatformBatchCard)`
  ${mediaQuery.uptoMobile} {
    width: 100%;
    max-width: 360px;
    .batch-thumbnail {
      height: 184px;
    }
  }
`;

const SingleBatchCardSection = ({
  label,
  batch,
  dataAnalytics,
  lastPrimarySourceSection
}) => {
  return (
    <Wrapper>
      {label ? (
        <Column>
          <StyH3>{label}</StyH3>
        </Column>
      ) : null}
      <CardWrapper
        label={label}
        key={batch.uid}
        batch={batch}
        lastPrimarySourceSection={lastPrimarySourceSection}
        dataAnalytics={dataAnalytics}
      />
    </Wrapper>
  );
};

export default SingleBatchCardSection;
